{
  "action": {
    "label": "Aktion"
  },
  "actionType": {
    "label": "Aktionstyp",
    "value": {
      "alert": "Warnung",
      "dvtm": "DVTM",
      "external_platform": "Externe Plattform",
      "group": "Gruppe",
      "iam": "IAM",
      "platform": "Plattform",
      "profile": "Profil",
      "sector": "Sektor",
      "talq_gateway": "TALQ-Gateway",
      "user": "Benutzer"
    }
  },
  "export": {
    "error": "Während der Generierung der CSV-Datei ist ein Fehler aufgetreten",
    "label": "Exportieren",
    "tooltip": "Wählen Sie Zeilen aus, um sie in das CSV-Format exportieren zu können"
  },
  "eventType": {
    "label": "Ereignistyp",
    "value": {
      "cyber": "Cyber",
      "device": "Gerät",
      "device_fleet": "Geräteflotte",
      "system": "System"
    }
  },
  "level": {
    "label": "Infoebene",
    "value": {
      "info": "Information",
      "warning": "Warnung",
      "error": "Fehler",
      "critical": "Kritisch"
    }
  },
  "timestamp": {
    "label": "Zeitstempel"
  },
  "filters": {
    "actions": {
      "placeholder": "Nach Aktionen suchen",
      "empty": "Keine Aktionen gefunden",
      "actionFound": "Keine Aktionen gefunden | {count} Aktion gefunden | {count} Aktionen gefunden"
    },
    "applications": {
      "declination": {
        "empty": "Keine Anwendung gefunden"
      },
      "label": "Anwendung",
      "placeholder": "Nach Anwendungen suchen",
      "type": {
        "empty": "Kein Typ"
      }
    },
    "clear": {
      "label": "Filter löschen"
    },
    "componentId": {
      "label": "Komponenten-ID",
      "value": {
        "all": "Alle"
      }
    },
    "dropdown": {
      "applyAsAFilter": "Als Filter anwenden",
      "button": {
        "label": "Filter",
        "title": "Filter anzeigen"
      },
      "properties": {
        "device": "Geräteeigenschaften",
        "email_address": "E-Mail-Eigenschaften",
        "gateway": "Gateway-Eigenschaften",
        "group": "Gruppeneigenschaften",
        "platform": "Plattformeigenschaften",
        "profile": "Profileigenschaften",
        "sector": "Sektoreigenschaften",
        "user": "Benutzereigenschaften",
        "pki_config": "PKI-Eigenschaften",
        "interface": "Schnittstelleneigenschaften"
      }
    },
    "entityClass": {
      "label": "Autor oder Assetklasse",
      "value": {
        "device": "Gerät",
        "email_address": "E-Mail-Adresse",
        "gateway": "Gateway",
        "group": "Gruppe",
        "platform": "Plattform",
        "profile": "Profil",
        "role": "Rolle",
        "sector": "Sektor",
        "user": "Benutzer"
      }
    },
    "entity": {
      "label": "Autor oder Asset"
    },
    "sortBy": {
      "label": "Sortierung",
      "value": {
        "datetime": "Chronologisch"
      }
    },
    "sortDirection": {
      "label": "Reihenfolge",
      "value": {
        "asc": "Aufsteigend",
        "desc": "Absteigend"
      }
    },
    "startDate": {
      "label": "Startdatum"
    },
    "status": {
      "label": "Fehler"
    },
    "timestamp": {
      "formatter": "YYYY-MM-DD",
      "periodSeparator": "bis",
      "placeholder": "Einen Zeitraum auswählen"
    },
    "users": {
      "placeholder": "Benutzer suchen"
    },
    "devices": {
      "model": {
        "empty": "Kein Modell"
      },
      "type": {
        "empty": "Kein Typ"
      }
    },
    "actionTypes": {
      "placeholder": "Nach Aktionstypen suchen",
      "empty": "Keine Aktionstypen gefunden",
      "actionTypesFound": "Keine Aktionstypen gefunden | {count} Aktionstyp gefunden | {count} Aktionstypen gefunden"
    }
  },
  "list": {
    "column": {
      "timestamp": {
        "format": "YYYY-MM-DD hh:mm:ss a"
      },
      "label": {
        "label": "Kennzeichnung"
      }
    },
    "empty": "Kein Protokoll gefunden",
    "unknown": "unbekannt"
  },
  "origin": {
    "label": "Herkunft",
    "values": {
      "mobileApplication": "Mobile Anwendung",
      "device": "Gerät",
      "thirdPartyApplication": "Drittanbieter-Anwendung",
      "lxConnect": "LX CONNECT"
    }
  }
}
